import { useWorkflowStages } from '@/hooks/useWorkflowStages';
import * as state from '@/state';
import { abyssColors } from '@/theme/colors';
import { Stack, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { StageActions } from './StageActions';
import { Break, Status, StatusChip } from './styles';
import { TimeTracking } from './TimeTracking';
import { AssigneeAvatar } from '../AssigneeAvatar';
import { useMemo } from 'react';

export const ZoneStageManager = () => {
  const selectedZone = useAtomValue(state.selectedZone);
  const zones = useAtomValue(state.zones);
  const { currentStage, stageColors, isFinalStage } = useWorkflowStages();
  const { picture, name } = useMemo(() => {
    if (!selectedZone || !zones?.length)
      return {
        picture: undefined,
        name: undefined,
      };
    const zone = zones.find((zone) => zone.id === selectedZone.id);
    const assignedUser = zone?.workflowStatus?.assignedToUser;
    return {
      picture: assignedUser?.picture,
      name: assignedUser?.name,
    };
  }, [selectedZone, zones]);

  return (
    <>
      {selectedZone && currentStage && (
        <Stack
          alignItems="center"
          direction="row"
          gap="1.6rem"
          height="3.8rem"
          paddingRight="1.6rem"
        >
          {!isFinalStage && (
            <>
              <Typography color={abyssColors.primary[500]} fontSize="1.4rem" lineHeight="normal">
                Current assignee:
              </Typography>
              <AssigneeAvatar
                sx={{
                  width: '140px',
                  height: '28px',
                  border: `1px solid ${abyssColors.primary[300]}`,
                  borderRadius: '2px',
                  color: abyssColors.primary[300],
                }}
                zoneId={selectedZone.id}
                assigneeName={name ?? undefined}
                profileImage={picture ?? undefined}
                details={currentStage}
                assingeFieldColor="#224063"
              />
              <Break />
            </>
          )}
          <Stack direction="row" gap="1.2rem" alignItems="center">
            <Typography color={abyssColors.primary[500]} fontSize="1.4rem" lineHeight="normal">
              Current stage:
            </Typography>
            <StatusChip sx={{ backgroundColor: stageColors?.backgroundColor }}>
              <Status color={stageColors?.color}>{currentStage.name}</Status>
            </StatusChip>
          </Stack>
          {!isFinalStage && (
            <>
              <Break />
              <TimeTracking />
            </>
          )}
          <StageActions />
        </Stack>
      )}
    </>
  );
};
